import clsx from 'clsx';
import React from 'react';
import { factory } from '../../factory/factory.utils.mjs';
import { Calendar } from '../DateInput/Calendar/Calendar.mjs';
import '../DateInput/DatesProvider/DatesProvider.mjs';
import { useDatesContext } from '../DateInput/DatesProvider/use-dates-context.mjs';
import { shiftTimezone } from '../DateInput/Day/Day.utils.mjs';
import classes from './DatePicker.module.css.mjs';
import { useDatesState } from './DatePicker.utils.mjs';

const DatePicker = factory((props, ref) => {
  const {
    type = "default",
    variant = "default",
    defaultValue = "month",
    value,
    onChange,
    getDayProps,
    allowSingleDateInRange,
    allowDeselect,
    onMouseLeave,
    numberOfColumns = 1,
    hideOutsideDates,
    className,
    __onDayMouseEnter,
    __onDayClick,
    __timezoneApplied,
    ...rest
  } = props;
  const { onDateChange, onRootMouseLeave, onHoveredDateChange, getControlProps } = useDatesState({
    type,
    level: "day",
    allowDeselect,
    allowSingleDateInRange,
    value,
    defaultValue,
    onChange,
    onMouseLeave,
    applyTimezone: !__timezoneApplied
  });
  const ctx = useDatesContext();
  return /* @__PURE__ */ React.createElement(
    Calendar,
    {
      ref,
      minLevel: "month",
      className: clsx(variant === "overlay" && classes.overlay, classes.datePicker, className, "kohler-date-picker-root"),
      onMouseLeave: onRootMouseLeave,
      numberOfColumns,
      hideOutsideDates: hideOutsideDates ?? numberOfColumns !== 1,
      __onDayMouseEnter: (_event, date) => {
        onHoveredDateChange(date);
        __onDayMouseEnter?.(_event, date);
      },
      __onDayClick: (_event, date) => {
        onDateChange(date);
        __onDayClick?.(_event, date);
      },
      getDayProps: (date) => ({
        ...getControlProps(date),
        ...getDayProps?.(date)
      }),
      ...rest,
      date: shiftTimezone("add", rest.date, ctx.getTimezone(), __timezoneApplied),
      __timezoneApplied: true
    }
  );
});

export { DatePicker };
